import { Position } from "@/common/theme/styleUtils";

export interface InteractionPanelProps {
	shadowTo: Position;
}

export enum InteractionState {
	Active,
	Waiting,
	Voicemail,
}

export enum InteractionPanelItemDescription {
	Active = 0,
	Waiting = 1,
	Offering = 2,
	Fallback = 3,
	Inbound = 4,
	InboundTransfer = 5,
	Outbound = 6,
	Missed = 7,
}

export enum InteractionPanelItemType {
	Call = 0,
	Generic = 1,
	Callback = 2,
	ParkedCall = 3,
	Email = 4,
	Voicemail = 5,
	WhatsApp = 6,
	ParkedEmail = 7,
	Webchat = 8,
	ParkedWhatsApp = 9,
	ParkedWebchat = 10,
}
